import { Box, Button, Container, Typography } from "@mui/material";
import UserTable from "../../features/user/components/UserTable";
import { Add } from "@mui/icons-material";
import CustomModal from "../../shared/CustomModal";
import { useState } from "react";
import { InterfaceUserEdit } from "../../features/user/data/user.interface";
import { useDispatch } from "react-redux";
import alertDelete from "../../shared/alert/alertDelete";
import { deleteUser, getUser } from "../../features/user/data/user.api";
import alertSuccess from "../../shared/alert/alertSuccess";
import UserForm from "../../features/user/components/UserForm";
import useAccess from "../../hooks/useAccess";

export default function UserPage() {

    const dispatch = useDispatch<any>()
    const access = useAccess()

    const [modalAdd, setModalAdd] = useState<boolean>(false)
    const [dataSelected, setDataSelected] = useState<InterfaceUserEdit | undefined>(undefined)

    const handleDelete = (id: number) => {
        alertDelete()
            .then(async isConfirmed => {
                if (isConfirmed) {
                    try {
                        await dispatch(deleteUser(id))
                        await alertSuccess("Berhasil menghapus data")
                        await dispatch(getUser())
                    } catch (error) { }
                }
            })
    }

    return (
        <Container>
            <CustomModal
                open={modalAdd}
                title="Tambah User"
                onClose={() => setModalAdd(false)}
                component={<UserForm mode="ADD" onSubmit={() => setModalAdd(false)} />}
            />
            <CustomModal
                open={Boolean(dataSelected)}
                title="Edit User"
                onClose={() => setDataSelected(undefined)}
                component={<UserForm mode="EDIT" data={dataSelected} onSubmit={() => setDataSelected(undefined)} />}
            />
            <br />
            <Typography variant="h3">User</Typography>
            {access("CREATE") && (
                <Box marginTop={1} display={"flex"} justifyContent={"flex-end"}>
                    <Button startIcon={<Add />} onClick={() => setModalAdd(true)}>Tambah</Button>
                </Box>
            )}
            <br />
            <UserTable onEdit={access("EDIT") ? setDataSelected : undefined} onDelete={access("DELETE") ? handleDelete : undefined} />
        </Container>
    )
}